import { render, staticRenderFns } from "./productManageCommissionDetail.vue?vue&type=template&id=1873acec&scoped=true"
import script from "./productManageCommissionDetail.vue?vue&type=script&lang=js"
export * from "./productManageCommissionDetail.vue?vue&type=script&lang=js"
import style0 from "./productManageCommissionDetail.vue?vue&type=style&index=0&id=1873acec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1873acec",
  null
  
)

export default component.exports